import { render, staticRenderFns } from "./container-wrapper.vue?vue&type=template&id=b98cf8dc&scoped=true&"
import script from "./container-wrapper.vue?vue&type=script&lang=js&"
export * from "./container-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./container-wrapper.vue?vue&type=style&index=0&id=b98cf8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98cf8dc",
  null
  
)

export default component.exports